module.exports = __webpack_public_path__ + "img/Alternative-Packaging-Solutions-650x340.66751b6f.png";